/**
 * PageRouteRegistryService 实现
 *
 * 页面路由注册服务的核心实现，负责页面路由的注册、存储、查找和卸载。
 */
/**
 * 页面路由注册服务
 *
 * ui-registry-mod 的核心服务之一，业务 Mod 通过此服务注册页面路由。
 */
export class PageRouteRegistryService {
    constructor(deps) {
        this.pages = [];
        this.eventBus = deps?.eventBusService;
    }
    registerPage(page) {
        // 1. 校验路由冲突
        const conflict = this.pages.find(p => p.path === page.path);
        if (conflict) {
            throw new Error(`Page route conflict: ${page.path} ` +
                `(already registered by ${conflict.modName ?? 'unknown'})`);
        }
        // 2. 存储路由
        this.pages.push(page);
        // 3. 发出事件
        if (this.eventBus) {
            this.eventBus.emit('page:registered', {
                path: page.path,
                modName: page.modName,
            });
        }
    }
    registerPages(pages) {
        // 先校验所有路由，确保原子性（全部成功或全部回滚）
        for (const page of pages) {
            const conflict = this.pages.find(p => p.path === page.path);
            if (conflict) {
                throw new Error(`Page route conflict: ${page.path} ` +
                    `(already registered by ${conflict.modName ?? 'unknown'})`);
            }
        }
        // 全部校验通过后批量注册
        for (const page of pages) {
            this.pages.push(page);
            if (this.eventBus) {
                this.eventBus.emit('page:registered', {
                    path: page.path,
                    modName: page.modName,
                });
            }
        }
    }
    unregisterModRoutes(modName) {
        const before = this.pages.length;
        this.pages = this.pages.filter(p => p.modName !== modName);
        const removed = before - this.pages.length;
        if (removed > 0 && this.eventBus) {
            this.eventBus.emit('page:unregistered', { modName, count: removed });
        }
    }
    getPages() {
        return [...this.pages];
    }
    getPagesByMod(modName) {
        return this.pages.filter(p => p.modName === modName);
    }
    getPageCount() {
        return this.pages.length;
    }
}
//# sourceMappingURL=page-route-registry.js.map